
<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Главная</a></li>
                <li>О нас</li>
            </ul>
        </div>
    </div>
</div>

<section class="about-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-image">
                    <img src="assets/img/about/secom1.png" class="shadow" alt="image">
                    <img src="assets/img/about/secom2.png" class="shadow" alt="image">
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <span class="sub-title">О нас</span>
                    <h2>Центр Образования и Развития Secom</h2>
                    <h6>Раскрытие и развитие потенциала.</h6>
                    <p>Лидер по  подготовке к ОРТ</p>
                    <p>Самый богатый опыт среди центров доп.образования, 16 филиалов по всей стране.  Работаем с 1996 г.</p>
                    <div class="features-text">
                        <h5><i class='bx bx-planet'></i>Места где каждый может раскрыть свой потенциал</h5>
                        <p>Более 300 учеников, получивших свыше 200 баллов в 2020 г.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="about-inner-area">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="about-text">
                        <h3>Подготовка к ОРТ</h3>
                        <p>Единственный центр, который: разрабатывает, издает и готовит по специальной авторской методике:</p>
                        <ul class="features-list">
                            <li><i class='bx bx-check'></i> Книги</li>
                            <li><i class='bx bx-check'></i> Сборники</li>
                            <li><i class='bx bx-check'></i> Тесты</li>
                            <li><i class='bx bx-check'></i> Онлайн курсы по ОРТ</li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="about-text">
                        <h3>Языковые курсы</h3>
                        <p>Английский язык, Русский язык, Кыргызский язык, Немецкий язык, Арабский язык, Испанский язык. SAT, IELTS.</p>
                        <ul class="features-list">
                            <li><i class='bx bx-check'></i> Книги, тесты</li>
                            <li><i class='bx bx-check'></i> Тест для определения уровня</li>
                            <li><i class='bx bx-check'></i> Учеба и отдых за границей</li>
                            <li><i class='bx bx-check'></i> Talking club</li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                    <div class="about-text">
                        <h3>Компьютерные курсы</h3>
                        <p>Профессиональные курсы в сфере высоких технологий, самые актуальные профессии будущего.</p>
                        <ul class="features-list">
                            <li><i class='bx bx-check'></i> Компьютерная грамотность</li>
                            <li><i class='bx bx-check'></i> Программирование</li>
                            <li><i class='bx bx-check'></i> 3D графика</li>
                            <li><i class='bx bx-check'></i> СММ, Графический дизайн</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-our-mission></app-our-mission>

<!--<section class="story-area ptb-100">-->
<!--    <app-our-story></app-our-story>-->
<!--</section>-->

<section class="funfacts-area ptb-100">
    <div class="container">
        <div class="funfacts-inner">
            <app-funfacts></app-funfacts>
            <div id="particles-js-circle-bubble"></div>
        </div>
    </div>
</section>

<!--<section class="values-area ptb-100">-->
<!--    <app-our-values></app-our-values>-->
<!--</section>-->

<!--<section class="testimonials-area">-->
<!--    <div class="container">-->
<!--        <div class="section-title">-->
<!--            <span class="sub-title">Testimonials</span>-->
<!--            <h2>What Students Says</h2>-->
<!--        </div>-->

<!--        <app-feedback-style-two></app-feedback-style-two>-->
<!--    </div>-->
<!--    <div id="particles-js-circle-bubble-2"></div>-->

<!--</section>-->
